<template>
  <div ref="dialogRoot" class="text-mode-empty-state" role="dialog" aria-modal="true" aria-labelledby="network-error-state__title">
    <div class="text-mode-empty-state__backdrop" />
    <section class="network-error-state__card">
      <v-icon size="56" class="network-error-state__icon">
        {{ icons.mdiCloudOffOutline }}
      </v-icon>
      <h2 id="network-error-state__title" class="network-error-state__title">
        {{ title || $t('app.assessment_mode.text.network_error.title') }}
      </h2>
      <p class="network-error-state__message">
        {{ message || $t('app.assessment_mode.text.network_error.message') }}
      </p>
      <div class="network-error-state__actions">
        <button
            type="button"
            class="network-error-state__back"
            @click="$emit('back')"
        >
          {{ $t('app.assessment_mode.coming_soon.back') }}
        </button>
        <button
            type="button"
            data-analytics-skip
            class="network-error-state__retry"
            @click="$emit('retry')"
        >
          {{ $t('app.assessment_mode.text.network_error.retry') }}
        </button>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import icons from '@/mixins/icons';
import { useDialogFocusTrap } from '@/composables/useDialogFocusTrap';

export default defineComponent({
  name: 'NetworkErrorState',
  mixins: [icons],
  props: { title: String, message: String },
  emits: ['retry', 'back'],
  setup() {
    const dialogRoot = ref<HTMLElement | null>(null);
    useDialogFocusTrap(dialogRoot);
    return { dialogRoot };
  },
});
</script>
